import { CookieService } from 'ngx-cookie-service';
import { isScullyRunning } from '@scullyio/ng-lib';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'clearcals-cookie-policy',
  templateUrl: './cookie-policy.component.html',
  styleUrls: ['./cookie-policy.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CookiePolicyComponent implements OnInit
{

    isCookiePresent: boolean;
    constructor(private cookieService: CookieService) { }

    ngOnInit(): void
    {
        if(!isScullyRunning())
        {
            if ( this.cookieService.check('clearcals.isPolicyAgreed') )
            {
                this.isCookiePresent = JSON.parse(this.cookieService.get('clearcals.isPolicyAgreed'));
            }
            else
            {
                this.isCookiePresent = false;
            }
        }
        else
        {
            this.isCookiePresent = true;
        }
    }


    toggleCookie(): void
    {
        var currentDate = new Date();
        currentDate.setTime(currentDate.getTime() + (30*24*60*60*1000));

        this.cookieService.set('clearcals.isPolicyAgreed', JSON.stringify(true), { expires: currentDate, sameSite: 'Lax' });
        this.isCookiePresent = true;
    }
}
